import React, {useState, useEffect} from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup'
import Toast from 'react-bootstrap/Toast'
import '../UpAllNight/ticks.css';
import { ButtonToolbar, ButtonGroup } from 'react-bootstrap';

const EditUser = props => {

    const user = props.user;
    const user_id = user.user_id;
    const user_name = user.user_name;
    const team_name = user.team_name;
    const cat = user.category;
    

    const [show, setShow] = useState(false);
    const [show2, setShow2] = useState(false);
    const [userName,setUserName] = useState(user_name);
    const [teamName,setTeamName] = useState(team_name);
    const [category,setCategory] = useState(cat);
  
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleShow2 = () => setShow2(true);

    

    
    const editUser = async (userID) => {
        const data = await fetch("https://settersbloc.com/api/edit_user.php",{
            method: 'POST',
            body: JSON.stringify({
                user_id: userID,
                user_name: userName,
                team_name: teamName,
                category: category
            })
        })
        .then(result => result.text())
        .then((result)=>{
            setShow(false);
            console.log(result)
        });
       props.onUpdateParent(); 
    }

    const handleUserNameChange = event => {
        setUserName(event.target.value)
    }

    const handleTeamNameChange = event => {
        setTeamName(event.target.value);
    }

    const handleCategoryChange = event => {
        setCategory(event.target.value);
    }
    const categories = ['Male','Female'];


    

    

   


    return(
        <div className='ticks'>
            
            <ButtonToolbar className="mb-3" aria-label="Toolbar with Button groups">
                <ButtonGroup className="me-2" aria-label="blagroup">
                    <Button onClick={handleShow} >Edit User </Button>
                </ButtonGroup>
            </ButtonToolbar>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Form.Group >
                    <InputGroup className="mb-2">
                        <InputGroup.Prepend>
                            <InputGroup.Text>User Name</InputGroup.Text>
                        </InputGroup.Prepend>
                        <Form.Control type="text" onChange={handleUserNameChange} value={userName} placeholder={user_name.split('_').join(' ')}/>
                    </InputGroup>  
                    <InputGroup className="mb-2">
                        <InputGroup.Prepend>
                            <InputGroup.Text>Team Name</InputGroup.Text>
                        </InputGroup.Prepend>
                        <Form.Control type="text" onChange={handleTeamNameChange} value={teamName} placeholder={team_name.split('_').join(' ')}/>
                    </InputGroup>  
                    <InputGroup className="mb-2">
                        <InputGroup.Prepend>
                            <InputGroup.Text>Category</InputGroup.Text>
                        </InputGroup.Prepend>
                        <Form.Control as="select" onChange={handleCategoryChange}>
                            <option value={category}>{categories[category]}</option>
                            <option value="0">Male</option>
                            <option value="1">Female</option>

                        </Form.Control>
                    </InputGroup>
                                         
                </Form.Group>  

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Close</Button>
                    <Button variant="primary" onClick={()=>editUser(user_id)}>Save changes</Button>
                </Modal.Footer>
            </Modal>  
        </div>
    )
}


export default EditUser;